let projects = [
  {
    name: 'Baker Grove',
    recordId: '22581',
    projectId: '111',
    archived: false,
    address: {
      street: '5639 Little Barn Rd.',
      city: 'Carmel',
      state: 'IN',
      zipCode: '46032',
    },
    location: {
      latitude: 39.8476,
      longitude: -86.1085,
    },
  },
  {
    name: 'Saratoga',
    recordId: '22581',
    projectId: '111',
    archived: false,
    address: {
      street: '2058 Spring Way',
      city: 'Fishers',
      state: 'IN',
      zipCode: '46032',
    },
    location: {
      latitude: 39.7434,
      longitude: -85.953,
    },
  },
  {
    name: 'East Creek Project',
    recordId: '22581',
    projectId: '111',
    archived: false,
    address: {
      street: '2728 Birch Rd.',
      city: 'Avon',
      state: 'IN',
      zipCode: '46032',
    },
    location: {
      latitude: 39.8292,
      longitude: -86.4098,
    },
  },
  {
    name: 'Lakeside Heights',
    recordId: '22581',
    projectId: '5536',
    archived: false,
    address: {
      street: '2235 Westwind Circle',
      city: 'Carmel',
      state: 'IN',
      zipCode: '46032',
    },
    location: {
      latitude: 39.9865,
      longitude: -86.1054,
    },
  },
  {
    name: 'Aquitaine',
    recordId: '22581',
    projectId: '111',
    archived: false,
    address: {
      street: '1453 Sparrow Street',
      city: 'Indianapolis',
      state: 'IN',
      zipCode: '46032',
    },
    location: {
      latitude: 39.9012,
      longitude: -86.3042,
    },
  },
  {
    name: 'Blue Ridge Estates',
    recordId: '22581',
    projectId: '111',
    archived: false,
    address: {
      street: '78 Kirkland Blvd.',
      city: 'Carmel',
      state: 'IN',
      zipCode: '46032',
    },
    location: {
      latitude: 39.7917,
      longitude: -86.0,
    },
  },
  {
    name: 'Fairview Farm',
    recordId: '22583',
    projectId: '5538',
    archived: false,
    address: {
      street: 'West Pine St.',
      city: 'Zionsville',
      state: 'IN',
      zipCode: '46077',
    },
    location: {
      latitude: 39.9492,
      longitude: -86.255,
    },
  },
  {
    name: 'Gray Castle',
    recordId: '22581',
    projectId: '111',
    archived: false,
    address: {
      street: '1066 Hastincs Cir.',
      city: 'Carmel',
      state: 'IN',
      zipCode: '46032',
    },
    location: {
      latitude: 39.7716,
      longitude: -86.257,
    },
  },
  {
    name: 'Wabash Village',
    recordId: '22581',
    projectId: '111',
    archived: false,
    address: {
      street: '10 Elk Dr.',
      city: 'Fishers',
      state: 'IN',
      zipCode: '46032',
    },
    location: {
      latitude: 39.9434,
      longitude: -85.953,
    },
  },
];

let projectDetails = {
  name: 'Fairview Farm',
  recordId: '22583',
  projectId: '5538',
  address: {
    street: 'West Pine St.',
    city: 'Zionsville',
    state: 'IN',
    zipCode: '46077',
  },
  location: {
    latitude: 39.9492,
    longitude: -86.2665,
  },
  currentDispatchSets: [
    {
      recordId: '105142',
      intendedUse: 'Trash',
      workOrderId: '40674',
      poAssigned: true,
      subProject: {
        recordId: '68777',
        subProjectId: '14971',
        name: '0041',
      },
      box: {
        recordId: '3080',
        boxSize: '30',
        boxNumber: '17039-30',
        boxId: '14',
      },
    },
    {
      recordId: '105393',
      intendedUse: 'Trash',
      workOrderId: '40925',
      poAssigned: false,
      subProject: {
        recordId: '68778',
        subProjectId: '14972',
        name: '0380',
      },
      box: {
        recordId: '3097',
        boxSize: '30',
        boxNumber: '29656-30',
        boxId: '31',
      },
    },
    {
      recordId: '105393',
      intendedUse: 'Trash',
      workOrderId: '40925',
      poAssigned: false,
      subProject: {
        recordId: '68778',
        subProjectId: '14972',
        name: '0360',
      },
      box: {
        recordId: '3097',
        boxSize: '30',
        boxNumber: '12737-30',
        boxId: '31',
      },
    },
  ],
};

let currentDispatchSets = [
  {
    recordId: '105483',
    workOrderId: '42065',
    intendedUse: 'Trash',
    dateCreated: '03/09/2018 09:12:44',
    dateSet: '03/10/2018',
    specialInstructions: 'Set box to the right of the drive.',
    tripType: 'Set',
    poAssigned: false,
    projectId: '5538',
    project: projectDetails,
    box: {
      boxId: '159',
      boxSize: '30',
      boxNumber: '35200-30',
    },
    subProject: {
      name: '0052',
    },
  },
  {
    recordId: '105483',
    workOrderId: '49917',
    intendedUse: 'Trash',
    dateSet: '03/04/2018',
    specialInstructions: '',
    tripType: 'Set',
    poAssigned: false,
    projectId: '5538',
    project: projectDetails,
    box: {
      boxId: '159',
      boxSize: '30',
      boxNumber: '35899-30',
    },
    subProject: {
      name: '0031',
    },
  },

  {
    recordId: '105485',
    workOrderId: '41017',
    intendedUse: 'Trash',
    dateSet: '02/28/2018',
    specialInstructions: '',
    tripType: 'Set',
    poAssigned: false,
    projectId: '5538',
    project: {
      projectId: '5538',
      name: 'Fairview Farm',
    },
    box: {
      boxId: '65',
      boxSize: '30',
      boxNumber: '32612-30',
    },
    subProject: {
      name: '0038',
    },
  },
  {
    recordId: '105482',
    workOrderId: '41014',
    intendedUse: 'Trash',
    dateSet: '03/01/2018',
    specialInstructions: '',
    tripType: 'Set',
    poAssigned: false,
    projectId: '5538',
    project: {
      projectId: '5538',
      name: 'Blue Ridge Estates',
    },
    box: {
      boxId: '223',
      boxSize: '30',
      boxNumber: '39533-30',
    },
    subProject: {
      name: '0005',
    },
  },
  {
    recordId: '105481',
    workOrderId: '41013',
    intendedUse: 'Trash',
    dateSet: '03/01/2018',
    specialInstructions: '',
    tripType: 'Set',
    poAssigned: false,
    projectId: '5538',
    project: {
      projectId: '5538',
      name: 'Baker Grove',
    },
    box: {
      boxId: '150',
      boxSize: '30',
      boxNumber: '34655-30',
    },
    subProject: {
      name: '0235',
    },
  },
  {
    recordId: '105481',
    workOrderId: '41013',
    intendedUse: 'Trash',
    dateSet: '02/12/2018',
    specialInstructions: '',
    tripType: 'Set',
    poAssigned: false,
    projectId: '5538',
    project: {
      projectId: '5538',
      name: 'East Creek Project',
    },
    box: {
      boxId: '150',
      boxSize: '30',
      boxNumber: '34655-30',
    },
    subProject: {
      name: '0120',
    },
  },
];

module.exports = {
  projects,
  projectDetails,
  currentDispatchSets,
};
